import React, { useState, useEffect } from "react";
import { trackEvent } from "../utils/posthog";

const READINESS_STORAGE_KEY = "realignmind_readiness_dismissed";

function ReadinessCheck({ onContinue, onCancel }) {
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const [showResources, setShowResources] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(READINESS_STORAGE_KEY) === "true") {
      onContinue();
    }
  }, [onContinue]);

  const handleContinue = () => {
    if (dontShowAgain) {
      localStorage.setItem(READINESS_STORAGE_KEY, "true");
    }
    trackEvent("readiness_check_completed", { dont_show_again: dontShowAgain });
    onContinue();
  };

  return (
    <div className="fixed inset-0 z-50 bg-session-bg sm:bg-black/50 flex items-stretch sm:items-center justify-center sm:p-4">
      <div className="w-full sm:max-w-md bg-session-bg-elevated text-session-text sm:rounded-2xl sm:shadow-xl flex flex-col">
        <div className="flex-1 px-6 pt-10 pb-6 sm:py-8 overflow-y-auto">
          <h2 className="text-2xl font-semibold text-session-text text-center mb-8">
            Before you begin
          </h2>

          <ul className="space-y-4 mb-8">
            <li className="flex items-start gap-3">
              <span className="text-2xl leading-none mt-0.5" role="img" aria-label="headphones">🎧</span>
              <span className="text-session-text">
                <strong className="font-medium">Use headphones</strong> so the sound moves between your ears.
              </span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-2xl leading-none mt-0.5" role="img" aria-label="quiet space">✨</span>
              <span className="text-session-text">
                Find a <strong className="font-medium">quiet, comfortable spot</strong>.
              </span>
            </li>
          </ul>

          <p className="text-sm text-session-text-secondary text-center mb-2">
            You can pause or stop at any time.
          </p>

          <div className="text-center">
            <button
              type="button"
              onClick={() => setShowResources(!showResources)}
              className="text-sm text-session-text-secondary hover:text-session-text transition"
            >
              {showResources ? "Hide support resources" : "Need support?"}
            </button>
            {showResources && (
              <div className="mt-3 text-sm text-session-text-secondary space-y-1 text-left bg-session-bg rounded-xl p-4">
                <p><strong>Emergency:</strong> Call 911</p>
                <p><strong>Suicide & Crisis Lifeline:</strong> Call or text 988</p>
                <p><strong>Crisis Text Line:</strong> Text HOME to 741741</p>
                <a href="/emergency-support" className="text-session-accent hover:underline block mt-2">More resources</a>
              </div>
            )}
          </div>
        </div>

        <div className="px-6 pb-6 sm:pb-8 sticky bottom-0 bg-session-bg-elevated border-t border-session-text-secondary/10 sm:border-0 pt-4">
          <button
            onClick={handleContinue}
            className="w-full bg-session-accent text-session-bg font-semibold py-4 rounded-xl hover:opacity-90 transition"
          >
            I'm ready, begin →
          </button>
          <div className="flex items-center justify-between mt-4">
            <label className="flex items-center gap-2 cursor-pointer text-sm text-session-text-secondary">
              <input
                type="checkbox"
                checked={dontShowAgain}
                onChange={(e) => setDontShowAgain(e.target.checked)}
                className="h-4 w-4 accent-session-accent"
              />
              <span>Don't show again</span>
            </label>
            <button
              type="button"
              onClick={onCancel}
              className="text-sm text-session-text-secondary hover:text-session-text transition"
            >
              Go back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export function resetReadinessPreference() {
  localStorage.removeItem(READINESS_STORAGE_KEY);
}

export default ReadinessCheck;
